import React from "react";
import { motion } from "framer-motion";
import { TProductDetail } from "../../types";
import { formatCurrency } from "../../utils/format-number";
import { Link } from "react-router-dom";

const StaticsImages = ({ products }: { products?: TProductDetail[] }) => {
  return (
    <div className="absolute left-0 flex flex-wrap items-center justify-center w-full h-full gap-4 top-6 lg:px-30 lg:py-4 ">
      {products?.slice(0, 4)?.map((item, index) => (
        <Link to={`/products/${item.code}`} key={index}>
          <div className="cursor-pointer min-h-[140px] lg:min-h-[210px] min-w-[150px] lg:min-w-[200px] drop-shadow-lg p-2 bg-cardOverlay backdrop-blur-md rounded-xl flex flex-col justify-between items-center">
            <motion.img
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 1.1 }}
              src={item.image}
              alt="icecream"
              className="w-24 -mt-10 lg:w-40 lg:-mt-[70px]"
            />
            <div className="flex flex-col items-center justify-end flex-grow w-full">
              <p className="mt-1 text-base font-semibold text-center lg:text-lg text-textColor max-w-[200px] line-clamp-1">
                {item.name}
              </p>
              <p className="text-[10px] lg:text-xs text-lightGray font-semibold my-2 lg:my-3 line-clamp-1 max-w-[200px]">
                {item.ingredients}
              </p>
              <p className="text-sm font-semibold text-headingColor">
                <span className="text-lg text-red-600">
                  {formatCurrency(item.price)}
                </span>
              </p>
            </div>
          </div>
        </Link>
      ))}
      {!products?.length &&
        [...Array(4)].map((_, index) => {
          return (
            <div
              key={index + "skeleton"}
              className="cursor-pointer min-h-[140px] lg:min-h-[210px] min-w-[150px] lg:min-w-[200px] drop-shadow-lg p-2 bg-cardOverlay backdrop-blur-md rounded-xl flex flex-col justify-between items-center"
            >
              <div className="w-24 -mt-10 lg:w-40 lg:-mt-[70px]"></div>
              <div className="flex flex-col items-center justify-end flex-grow w-full">
                <div className="w-full h-6 bg-gray-300 rounded-full animate-pulse opacity-8"></div>
                <div className="w-10/12 bg-gray-300 rounded-full animate-pulse opacity-8 my-2 h-3 lg:my-3 line-clamp-1 max-w-[200px] opacity-8"></div>
                <div className="w-2/4 bg-gray-300 rounded-full animate-pulse opacity-8 my-2 h-6 lg:my-3 line-clamp-1 max-w-[200px] opacity-8"></div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default StaticsImages;
